export default "__VITE_ASSET__ChckG5Uw__"